export default __webpack_public_path__ + "static/media/rescue.08c769d4.png";